import { __decorate } from "tslib";
import Component from 'vue-class-component';
import SimpleCrud from '@/components/SimpleCrud.vue';
import Vue from 'vue';
import { VALIDATION_RULES } from '@/constants/ValidationRules';
import { INPUT_TYPES } from '@/constants/InputTypes';
import { BALANCES } from "@/constants/Balances";
import moment from "moment";
import { TRANSACTION_CATEGORIES } from "@/constants/TransactionCategories";
import Instructor from "@/classes/Instructor";
let TransactionsOverview = class TransactionsOverview extends Vue {
    title = 'Transakce';
    storeModule = 'transaction';
    formAddTitle = 'Nová transakce';
    formEditTitle = '';
    isRevertMode = false;
    get headers() {
        return [
            {
                text: 'Datum a čas',
                value: 'data.dateTime',
                type: INPUT_TYPES.DATETIME,
                rules: [],
                customPrint: value => moment(value).format('DD.MM.YYYY HH:mm'),
            },
            {
                text: 'Kategorie',
                value: 'data.category',
                rules: [VALIDATION_RULES.REQUIRED],
                type: INPUT_TYPES.SELECT,
                selectItems: TRANSACTION_CATEGORIES,
                selectValue: 'id',
                selectText: 'title'
            },
            {
                text: 'Popis',
                value: 'data.description',
                rules: [VALIDATION_RULES.REQUIRED],
                type: INPUT_TYPES.TEXT,
            },
            {
                text: 'Od',
                value: 'data.from',
                rules: [
                    VALIDATION_RULES.REQUIRED,
                ],
                specialRules: [
                    { rule: VALIDATION_RULES.NOT_SAME_AS, path: 'data.to' },
                ],
                type: INPUT_TYPES.AUTOCOMPLETE,
                selectItems: this.transactionTargets,
                selectValue: 'id',
                selectText: (item) => `${item}`,
                customPrint: (value, item) => `${this.instructorsByKey[item.data.from]}`,
            },
            {
                text: 'Pro',
                value: 'data.to',
                rules: [
                    VALIDATION_RULES.REQUIRED,
                ],
                specialRules: [
                    { rule: VALIDATION_RULES.NOT_SAME_AS, path: 'data.from' },
                ],
                type: INPUT_TYPES.AUTOCOMPLETE,
                selectItems: this.transactionTargets,
                selectValue: 'id',
                selectText: (item) => `${item}`,
                customPrint: (value, item) => `${this.instructorsByKey[item.data.to]}`,
            },
            {
                text: 'Částka',
                value: 'data.value',
                rules: this.valueRules,
                type: INPUT_TYPES.NUMBER,
                customPrint: value => value.toLocaleString() + ',- Kč',
            },
            {
                text: 'Uzavřeno',
                value: 'data.createdAt',
                type: INPUT_TYPES.TEXT,
                rules: [],
                notEditable: true,
                customPrint: value => value ? moment(value).format('DD.MM.YYYY HH:mm') : '',
            },
            {
                text: '',
                value: 'actions',
                sortable: false,
                notEditable: true,
                rules: [],
                type: INPUT_TYPES.TEXT,
            },
        ];
    }
    get isAdmin() {
        return this.$store.getters['user/isAdmin'];
    }
    canRevert(item) {
        return item.data.value !== 0 && this.$store.getters['user/isAdmin'];
    }
    get valueRules() {
        const rules = [VALIDATION_RULES.REQUIRED, VALIDATION_RULES.NUMBER];
        if (this.isRevertMode) {
            rules.push((v) => v !== 0 || 'Hodnota opravy nesmí být nula');
        }
        return rules;
    }
    onDialogClosed() {
        this.isRevertMode = false;
    }
    revertItem(item) {
        this.isRevertMode = true;
        const revertData = {
            from: item.data.from,
            to: item.data.to,
            category: item.data.category,
            value: -item.data.value,
            description: 'Oprava: ' + item.data.description,
            dateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
            createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
            deletedAt: null,
        };
        this.$refs.simpleCrud.editItem({
            id: this.defaultItem.id,
            data: revertData,
        });
    }
    defaultItem = {
        id: 'new-transaction',
        data: {
            from: '',
            to: '',
            value: 0,
            dateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
            createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
            category: '',
            description: '',
            deletedAt: null,
        },
    };
    filter = (value, search, item) => {
        const category = TRANSACTION_CATEGORIES.find(cat => cat.id === value);
        const from = this.transactionTargets.find(ins => ins.id === value);
        const to = this.transactionTargets.find(ins => ins.id === value);
        return (category && category.title.toLowerCase().indexOf(search.toLowerCase()) !== -1)
            || item.data.description.toLowerCase().indexOf(search.toLowerCase()) !== -1
            || ((from?.data.name + ' ' + (to?.data.surname ?? '')).toLowerCase().indexOf(search.toLowerCase()) !== -1);
    };
    get transactionTargets() {
        return [
            ...this.balancesAsInstructors,
            ...this.instructors,
        ];
    }
    get balancesAsInstructors() {
        return [
            new Instructor({
                id: BALANCES.MAIN_BALANCE,
                data: {
                    name: '',
                    surname: 'Hlavní účet',
                    email: '',
                    phone: null,
                    grade_id: null,
                    role: 100,
                    notifications: [],
                    image: null,
                    balance: 0,
                    paysTaxes: false,
                }
            }),
            new Instructor({
                id: BALANCES.EXTERNAL_BALANCE,
                data: {
                    name: '',
                    surname: 'Externí výdaje a příjmy',
                    email: '',
                    phone: null,
                    grade_id: null,
                    role: 100,
                    notifications: [],
                    image: null,
                    balance: 0,
                    paysTaxes: false,
                }
            }),
            new Instructor({
                id: BALANCES.TAX_BALANCE,
                data: {
                    name: '',
                    surname: 'Daň',
                    email: '',
                    phone: null,
                    grade_id: null,
                    role: 100,
                    notifications: [],
                    image: null,
                    balance: 0,
                    paysTaxes: false,
                }
            }),
            new Instructor({
                id: 'cash',
                data: {
                    name: '',
                    surname: 'Hotovost',
                    email: '',
                    phone: null,
                    grade_id: null,
                    role: 100,
                    notifications: [],
                    image: null,
                    balance: 0,
                    paysTaxes: false,
                }
            }),
        ];
    }
    get instructors() {
        return this.$store.getters['instructor/all'];
    }
    get instructorsByKey() {
        let instructors = {};
        this.transactionTargets.map((instructor) => {
            Vue.set(instructors, instructor.id, instructor);
        });
        return instructors;
    }
};
TransactionsOverview = __decorate([
    Component({
        components: {
            SimpleCrud,
        },
    })
], TransactionsOverview);
export default TransactionsOverview;
